import React from "react";
import { useField } from "formik";
import SearchableSelect from "./SearchableSelect";

/**
 * Formik-bound version of SearchableSelect — drop-in replacement for
 * <Field as="select">, matching InputField's label/error conventions.
 */
const SearchableSelectField = ({
    name,
    label,
    required,
    options,
    placeholder,
    disable,
    className = "",
    ...rest
}) => {
    const [field, meta, helpers] = useField(name);

    return (
        <div className="form-control w-full">
            {label && (
                <label htmlFor={name} className="block text-sm font-semibold text-gray-700 mb-1.5">
                    {label}
                    {required && <span className="text-red-500 ml-1">*</span>}
                </label>
            )}
            <SearchableSelect
                id={name}
                name={name}
                value={field.value}
                onChange={(v) => helpers.setValue(v)}
                options={options}
                placeholder={placeholder}
                disabled={disable}
                error={meta.touched && !!meta.error}
                className={`py-2.5 px-4 text-sm border rounded-xl focus:ring-2 focus:ring-primary/40 focus:border-primary transition-all duration-200 ${
                    disable ? "bg-gray-100 cursor-not-allowed" : "bg-white hover:border-gray-400"
                } ${className}`}
                {...rest}
            />
            {meta.touched && meta.error && (
                <p className="mt-1 text-xs text-red-600 flex items-center gap-1 font-medium" role="alert">
                    <svg className="w-3.5 h-3.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                        />
                    </svg>
                    {meta.error}
                </p>
            )}
        </div>
    );
};

export default SearchableSelectField;
